import React from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {_transl} from "../../../../store/localization/TranslMessasge";
import UserGroupsGrid from "./UserGroupsGrid";
import {UserGroupsTranslationKey} from "./UserGroupsTranslationKey";

export default function UserGroupsPage() {

    return (
        <Page>
            <PageHeader>
                <PageTitle title={_transl(UserGroupsTranslationKey.USER_GROUPS)} />
            </PageHeader>
            <PageContent>
                <UserGroupsGrid/>
            </PageContent>
        </Page>
    );
}
